/**
 * Formata um número de telefone brasileiro
 * @param phone - Número de telefone (com ou sem formatação)
 * @returns Telefone formatado no padrão brasileiro
 */
export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return 'Não informado';

  // Remove todos os caracteres não numéricos
  const cleanPhone = phone.replace(/\D/g, '');

  // Se tem 11 dígitos (celular com DDD)
  if (cleanPhone.length === 11) {
    return cleanPhone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  }

  // Se tem 10 dígitos (telefone fixo com DDD)
  if (cleanPhone.length === 10) {
    return cleanPhone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  }

  // Se tem 9 dígitos (celular sem DDD)
  if (cleanPhone.length === 9) {
    return cleanPhone.replace(/(\d{5})(\d{4})/, '$1-$2');
  }

  // Se tem 8 dígitos (telefone fixo sem DDD)
  if (cleanPhone.length === 8) {
    return cleanPhone.replace(/(\d{4})(\d{4})/, '$1-$2');
  }

  // Se não se encaixa em nenhum padrão, retorna como está
  return phone;
}

/**
 * Formata um número de WhatsApp brasileiro
 * @param phone - Número de telefone
 * @returns Telefone formatado com link do WhatsApp
 */
export function formatWhatsApp(phone: string | null | undefined): {
  formatted: string;
  link: string;
} {
  if (!phone) {
    return { formatted: 'Não informado', link: '' };
  }

  const cleanPhone = phone.replace(/\D/g, '');
  const formatted = formatPhone(phone);

  // Adiciona o código do país se necessário
  const whatsappNumber = cleanPhone.length === 11 ? `55${cleanPhone}` : `55${cleanPhone}`;
  const link = `https://wa.me/${whatsappNumber}`;

  return { formatted, link };
}
